module.exports = __webpack_public_path__ + "8adae8520813d888fd5381d005ffdeb3.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/images/brothers-shimla.jpg
// module id = 1075
// module chunks = 0